import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function NewAccountDialog({ open, onOpenChange, form, setForm, branches, onSave }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="account-dialog" className="max-w-md">
        <DialogHeader><DialogTitle className="font-heading">Nueva cuenta bancaria</DialogTitle>
          <DialogDescription>Crea una cuenta para importar sus extractos bancarios.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div className="space-y-1.5"><Label>Nombre</Label>
            <Input data-testid="account-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ej: CaixaBank principal" /></div>
          <div className="space-y-1.5"><Label>Banco</Label>
            <Input data-testid="account-bank-input" value={form.bank} onChange={(e) => setForm({ ...form, bank: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>IBAN</Label>
            <Input data-testid="account-iban-input" value={form.iban} onChange={(e) => setForm({ ...form, iban: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Tipo</Label>
            <Select value={form.kind} onValueChange={(v) => setForm({ ...form, kind: v })}>
              <SelectTrigger data-testid="account-kind-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="cuenta">Cuenta bancaria</SelectItem>
                <SelectItem value="tarjeta">Tarjeta</SelectItem>
                <SelectItem value="efectivo">Efectivo / caja</SelectItem>
              </SelectContent>
            </Select></div>
          <div className="space-y-1.5"><Label>Sucursal</Label>
            <Select value={form.branch_id || "all"} onValueChange={(v) => setForm({ ...form, branch_id: v === "all" ? "" : v })}>
              <SelectTrigger data-testid="account-branch-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas (cuenta general)</SelectItem>
                {branches.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}
              </SelectContent>
            </Select></div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button data-testid="account-save-button" onClick={onSave} disabled={!form.name}
            className="bg-[#D9381E] hover:bg-[#B91C1C] text-white">Crear</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
